import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor() { }

  sendDataToNativeApp(payload: any): boolean {
    try {
      const data = JSON.stringify(payload);
      if ((window as any).AndroidInterface?.postMessage) {
        (window as any).AndroidInterface.postMessage(data);
        return true;
      } else if ((window as any).webkit?.messageHandlers?.nativeApp) {
        (window as any).webkit.messageHandlers.nativeApp.postMessage(data);
        return true;
      } else {
        console.warn('No native interface found to communicate with.');
        return false;
      }
    } catch (error) {
      console.error('Failed to send data to native app:', error);
      return false;
    }
  }

}
